import { PartnersDocDept } from "src/entities/partnersDocDept/ui/PartnersDocDept";

export const PartnersDocDeptPage = () => {
  return <PartnersDocDept />;
};
